/**
 * Shared schema.org structured-data builders.
 * Each returns a JSON-LD object ready for the SEO component's structuredData prop.
 */

const SITE_URL = 'https://upscale.no';
const LOGO = `${SITE_URL}/logo.png`;

export const organization = {
  '@type': 'Organization',
  '@id': `${SITE_URL}/#organization`,
  name: 'Upscale Growth AS',
  alternateName: 'Upscale',
  url: SITE_URL,
  logo: LOGO,
  description:
    'Growth and marketing agency helping startups gain early-adopter traction and sustained user growth through data-driven strategies.',
  email: 'arjun@upscale.no',
  telephone: '+47-967-18-941',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Rådhusgata 9',
    addressLocality: 'Oslo',
    postalCode: '0151',
    addressCountry: 'NO',
  },
  founder: { '@type': 'Person', name: 'Arjun Bhatt' },
  foundingDate: '2023',
  areaServed: ['NO', 'IN', 'GB'],
  sameAs: ['https://www.linkedin.com/company/upscale-growth'],
};

export const website = {
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: 'Upscale',
  publisher: { '@id': `${SITE_URL}/#organization` },
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/?s={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export const localBusiness = {
  '@type': 'ProfessionalService',
  '@id': `${SITE_URL}/#localbusiness`,
  name: 'Upscale Growth AS',
  image: LOGO,
  url: SITE_URL,
  telephone: '+47-967-18-941',
  email: 'arjun@upscale.no',
  priceRange: '$$',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Rådhusgata 9',
    addressLocality: 'Oslo',
    postalCode: '0151',
    addressCountry: 'NO',
  },
  geo: { '@type': 'GeoCoordinates', latitude: 59.9111, longitude: 10.7404 },
  areaServed: ['Norway', 'India', 'United Kingdom'],
  serviceArea: { '@type': 'Country', name: 'Norway' },
};

export const breadcrumb = (items) => ({
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    name: it.name,
    item: it.url,
  })),
});

export const wrap = (graph) => ({
  '@context': 'https://schema.org',
  '@graph': graph,
});

export { SITE_URL };
